export default "__VITE_ASSET__DXrprUVW__"